
import confirmationDialog from "../dialogs/confirmation-dialog.vue";
import { mapState, mapActions } from "vuex";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";

export default {
  components: { confirmationDialog, CreateEditAddonDialog },
  data() {
    return {
      panel: "",
      deleteLoading: false,
      showDeleteConfirmationDialog: false,
      showEditAddonDialog: false
    };
  },
  props: {
    addon: {}
  },
  methods: {
    ...mapActions("menu", ["getAddons", "deleteAddon"]),
    async handleDeleteAddon() {
      this.deleteLoading = true;
      try {
        await this.deleteAddon(this.addon.id);
        await this.getAddons({ forceFetch: true });
        this.$nuxt.$emit("show-toast", {
          text: "Add-on removed successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.deleteLoading = false;
      this.showDeleteConfirmationDialog = false;
    }
  }
};
